var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"field",staticClass:"code-field",attrs:{"value":_vm.value,"inputmode":"numeric","autocomplete":"one-time-code","maxlength":"9","outlined":""},on:{"input":_vm.onInput,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('enter')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }